var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralApplynow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.821,
    height: 101.821,
    viewBox: "0 0 101.821 101.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_document-text",
    "data-name": "vuesax/bulk/document-text",
    transform: "translate(-492 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-text",
    transform: "translate(492 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H101.821V101.821H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M76.366,21.213V63.638c0,12.728-6.364,21.213-21.213,21.213H21.213C6.364,84.851,0,76.366,0,63.638V21.213C0,8.485,6.364,0,21.213,0h33.94C70,0,76.366,8.485,76.366,21.213Z",
    transform: "translate(12.728 8.485)",
    fill: "#ccdcda"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(58.335 15.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M20.152,23.334H11.667A11.66,11.66,0,0,1,0,11.667V3.182A3.205,3.205,0,0,1,3.182,0,3.205,3.205,0,0,1,6.364,3.182v8.485a5.305,5.305,0,0,0,5.3,5.3h8.485a3.182,3.182,0,1,1,0,6.364Z",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(30.759 51.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M20.152,6.364H3.182A3.205,3.205,0,0,1,0,3.182,3.205,3.205,0,0,1,3.182,0h16.97a3.205,3.205,0,0,1,3.182,3.182A3.205,3.205,0,0,1,20.152,6.364Z",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group",
    transform: "translate(30.759 68.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M37.122,6.364H3.182A3.205,3.205,0,0,1,0,3.182,3.205,3.205,0,0,1,3.182,0h33.94A3.205,3.205,0,0,1,40.3,3.182,3.205,3.205,0,0,1,37.122,6.364Z",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H101.821V101.821H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralApplynow);
export default __webpack_public_path__ + "static/media/university-general-applynow.a253eb17c5135b31fe0d2c39474a7b48.svg";
export { ForwardRef as ReactComponent };